<template>
  <div class="add-to-portfolio">
    <Portal to="breadcrumb_addScreenerInstrumentsToPortfolio" v-if="instruments">
      Zu Portfolio hinzufügen
    </Portal>

    <fin-add-to-portfolio :instruments="instruments"
                          :title="title"
                          :to="to"
                          @addToPortfolioDone="$emit('addToPortfolioDone')"/>
  </div>
</template>

<script>
import FinAddToPortfolio from '@/components/common/portfolio/AddToPortfolio/index'

export default {
  name: 'fin-screener-add-to-portfolio',
  components: {
    FinAddToPortfolio
  },
  props: {
    instruments: {
      type: Array
    },
    title: {
      type: String
    },
    to: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-portfolio {
  background-color: #fff;
}
</style>
